/* @flow */
import React from 'react';

import Table from 'components/UIKit/Table';
import SamplesColumns from './SamplesColumns';
import SamplesRows from './SamplesRows';

export default function SamplesTable({
  children, router, sort, order
}: any): React.Element {
  return (
    <Table>
      <SamplesColumns sort={sort} order={order} />
      <SamplesRows router={router}>
        {children}
      </SamplesRows>
    </Table>
  );
}
